import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Form from '../form/Form';
import FieldGroup from '../field_group/FieldGroup';

import { listBuildingType } from '../../redux/building_type/building_type_actions';
import { getErrorValue } from '../../utils/utility';
import { requiredValidator } from '../field_group/validators';

export class BuildingDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
  }

  getBuildingData() {
    return {
      ...this.formRef.getFormData(),
      ...this.state,
    };
  }

  componentDidMount() {
    this.props.listBuildingType();
  }

  renderOption(item, prefix) {
    return (
      <option key={prefix ? `${prefix}${item.id}`: item.id} value={item.id}>
        {item.name}
      </option>
    );
  }

  render() {
    const {
      name,
      building_type_id,
      description,
      image,
    } = this.props.building || {};

    const { disabled, fieldErrors, listProvince, t, ...otherAttr } = this.props;
    const customAttr = { disabled };

    const lang = this.props.i18n.language.split('-')[0];
    return (
      <Form
        {...otherAttr}
        image={image}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
        ref={ref => (this.formRef = ref)}
      >
        <FieldGroup
          id="building-name"
          field="name"
          type="text"
          label={t('building name')}
          placeholder={t('building name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="building-building-type"
          field="building_type_id"
          componentClass="select"
          label={t('building type')}
          value={building_type_id}
          defaultDirty={true}
          errorMessage={getErrorValue(fieldErrors, 'building_type_id')}
          {...customAttr}
          disabled={!!(this.props.isProvinceLoading || disabled)}
        >
          {this.props.buildingTypes.map(type => this.renderOption(({...type, name: type[`name_${lang}`]}), 'bt'))}
        </FieldGroup>
        <FieldGroup
          id="building-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          errorMessage={getErrorValue(fieldErrors, 'description')}
          {...customAttr}
        />
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  buildingTypes: state.buildingType.orderedIds.map(id => state.buildingType.buildingTypes[id]),
  isBuildingTypeLoading: state.buildingType.loading,
  errorMessage: state.province.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  listBuildingType: () => dispatch(listBuildingType()),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(BuildingDetail),
);



// WEBPACK FOOTER //
// ./src/components/building_detail/BuildingDetail.js